import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { BasicButtonColors, BasicButtonModes, BasicButtonSizes } from '@app/shared/enums/buttons';
import { NotificationService } from '@shared/services/notification.service';
import { Observable, map, take, tap } from 'rxjs';
import { IMessages } from '@shared/interfaces/messages';
import { NotificationsCenterService } from '@app/admin-station/notifications-center/services/notifications-center.service';
import { NotificationOptions } from '@app/main/enums/notification-options.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserService } from '../../../admin-station/work-center/user/services/user.service';

@UntilDestroy()
@Component({
  selector: 'cm-header-notifications',
  templateUrl: './header-notifications.component.html',
  styleUrls: ['./header-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderNotificationsComponent implements AfterViewInit, OnDestroy {

  @ViewChild('cmNotificationMain', { static: false }) cmNotificationMain!: ElementRef;
  private resizeObserver!: ResizeObserver;
  isSmallSize: boolean;

  BasicButtonModes = BasicButtonModes;
  BasicButtonSizes = BasicButtonSizes;
  BasicButtonColors = BasicButtonColors;
  notificationOptions: string[] = Object.values(NotificationOptions);
  notifications$: Observable<IMessages[]> = this.notificationService.notifications$;
  showSpinner$: Observable<boolean> = this.notificationService.showSpinner$;

  public displayNotification$: Observable<IMessages[]>;

  constructor(
    private notificationService: NotificationService,
    private userService: UserService,
    private cd: ChangeDetectorRef
  ) {
    this.displayNotification$ = this.notifications$;
  }

  ngAfterViewInit(): void {
    this.checkWrapperWidth();
  }

  ngOnDestroy() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }

  private checkWrapperWidth() {
    this.resizeObserver = new ResizeObserver(() => {
      const notificationMain = this.cmNotificationMain.nativeElement;
      this.isSmallSize = notificationMain.clientWidth < 350;
      this.cd.detectChanges();
    });
    this.resizeObserver.observe(this.cmNotificationMain.nativeElement);
  }

  selectOption({ index }): void {
    const option = {
      '0': NotificationOptions.ALL,
      '1': NotificationOptions.READ,
      '2': NotificationOptions.UNREAD,
    }[index];

    this.notificationService.notificationChipOption = option;

    switch (option) {
      case NotificationOptions.ALL:
        this.displayNotification$ = this.notificationService.notifications$;
        break;
      case NotificationOptions.READ:
        this.displayNotification$ = this.notificationService.notifications$.pipe(
          map((messages: IMessages[]) => {
            return messages.filter((message) => message.readDate);
          })
        );
        break;
      case NotificationOptions.UNREAD:
        this.displayNotification$ = this.notificationService.unreadNotifications$;
        break;
      default:
        this.displayNotification$ = this.notificationService.notifications$;
        break;
    }
  }

  public markAllAsRead(): void {
    this.userService
      .markAllAsRead()
      .pipe(
        untilDestroyed(this),
        tap(() => {
          this.notificationService.refreshNotifications.next();
        })
      )
      .subscribe();
  }

  public refreshNotifications(): void {
    this.notificationService.refreshNotifications.next();
  }
}
